import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import type { SiteLocationRow } from '../../types/project';

interface DeleteLocationDialogProps {
  open: boolean;
  location: SiteLocationRow | null;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteLocationDialog = ({ open, location, onClose, onConfirm }: DeleteLocationDialogProps) => {
  if (!location) return null;

  const hasSamples = location.SampleCount > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ fontWeight: 700, pb: 0.5 }}>Delete Location</DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2.5 }}>
        {hasSamples ? (
          <Typography variant="body2" color="error">
            Cannot delete &quot;{location.LocationName}&quot; because it has {location.SampleCount} sample(s).
            Please delete or move those samples first.
          </Typography>
        ) : (
          <Typography variant="body2">
            Are you sure you want to delete &quot;{location.LocationName}&quot; ({location.LocationId})?
            This action cannot be undone.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>Cancel</Button>
        {!hasSamples && (
          <Button variant="contained" color="error" onClick={onConfirm}
            sx={{ textTransform: 'none', fontWeight: 600 }}>
            Delete
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
